<template>
    <div class="menu-page">
        <v-row>
            <v-col cols="12" lg="8" md="7">
                <v-card class="mb-4">
                    <v-card-text>
                        <v-form @submit.prevent="save">
                            <v-row>
                                <v-col cols="12">
                                    <div class="profile-picture">
                                        <v-avatar size="90" class="mr-8">
                                            <v-img :src="userImage" v-if="userImage" />
                                            <div v-else class="w-full h-full primary d-flex justify-center">
                                                <v-icon color="white" style="font-size:120px">mdi-account</v-icon>
                                            </div>
                                        </v-avatar>

                                        <div>
                                            <v-btn color="primary" class="mb-2 mb-sm-0 mr-sm-2" outlined @click="pickFile">Alterar Foto</v-btn>
                                            <v-btn color="error" outlined @click="removeImage">Remover Foto</v-btn>

                                            <div class="w-full mt-4">
                                                Formatos suportados: JPG e PNG
                                            </div>
                                        </div>
                                    </div>
                                </v-col>

                                <v-col cols="12">
                                    <v-text-field v-model="user.name" label="Nome" required outlined hide-details="auto" />
                                </v-col>

                                <v-col cols="12">
                                    <v-text-field v-model="user.business_name" label="Empresa" required outlined hide-details="auto" />
                                </v-col>

                                <v-col cols="12">
                                    <v-text-field v-model="user.email" label="E-mail" required outlined hide-details="auto" />
                                </v-col>

                                <v-col cols="12" class="d-flex">
                                    <v-spacer />
                                    <v-btn color="error" class="mr-2" @click="load" :disabled="saving">Cancelar</v-btn>
                                    <v-btn color="primary" type="submit" :loading="saving">Salvar</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>

            <v-col cols="12" lg="4" md="5">
                <v-card>
                    <v-card-title>
                        Redefinir senha
                    </v-card-title>
                    <v-card-text>
                        <v-form @submit.prevent="updatePassword">
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field v-model="updatePasswordForm.oldPassword" label="Senha atual" outlined hide-details="auto" :type="updatePasswordForm.showPassword ? 'text' : 'password'" :append-icon="updatePasswordForm.showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                        @click:append="updatePasswordForm.showPassword = !updatePasswordForm.showPassword" />
                                </v-col>

                                <v-col cols="12" class="pb-0">
                                    <v-text-field v-model="updatePasswordForm.newPassword" label="Nova senha" outlined hide-details="auto" messages="A senha precisa ter ao menos 8 dígitos" :type="updatePasswordForm.showPassword ? 'text' : 'password'" />
                                </v-col>

                                <v-col cols="12">
                                    <v-text-field v-model="updatePasswordForm.confirmNewPassword" label="Confirmar nova senha" outlined hide-details="auto" :type="updatePasswordForm.showPassword ? 'text' : 'password'" />
                                </v-col>

                                <v-col cols="12" class="d-flex justify-end">
                                    <v-btn color="primary" type="submit">Redefinir senha</v-btn>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>



    </div>
</template>
  
<script>
import Api from "@/lib/Api";
import { emitToastr } from "@/lib/Utils";

export default {
    name: "PerfilView",

    data() {
        return {
            user: {
                name: '',
                email: '',
                business_name: '',
                profile_picture: ''
            },
            saving: false,
            image: {
                file: null,
                preview: null,
            },
            updatePasswordForm: {
                showPassword: false,
                oldPassword: '',
                newPassword: '',
                confirmNewPassword: ''
            }
        };
    },
    computed: {
        userImage() {
            return this.image.preview || this.user.profile_picture;
        },
    },
    mounted() {
        this.load()
    },
    methods: {
        async load() {
            const user = await Api.getRemoteUser();

            this.user = user;

            this.image.preview = null;
            this.image.file = null;
        },

        async pickFile() {
            const input = document.createElement('input')

            input.type = 'file'
            input.accept = 'image/jpeg, image/png'

            input.onchange = async (e) => {
                const file = e.target.files[0]

                this.setImage(file)
            }

            input.click()
        },
        removeImage() {
            this.image.file = null
            this.user.profile_picture = 'remove'
        },
        setImage(file) {
            const preview = URL.createObjectURL(file)

            this.image.file = file
            this.image.preview = preview
        },
        async saveUserImage(file) {
            const response = await Api.uploadProfilePicture(file);

            if (response.error) {
                emitToastr('error', response.message);
                return
            }

            this.user.profile_picture = response.message;
        },
        async save() {
            this.saving = true;

            if (this.image.file) {
                await this.saveUserImage(this.image.file);
            }

            const response = await Api.changeUserData(this.user);
            this.saving = false;

            if (response.error) {
                emitToastr('error', response.message);
                return;
            }
            else {
                if (!response.error && response.message) {
                    this.$root.$refs.global.updateUser(response.message);
                    emitToastr('success', 'Dados atualizados com sucesso');
                }
            }
        },
        async updatePassword() {
            const { oldPassword, newPassword, confirmNewPassword } = this.updatePasswordForm;

            if (!oldPassword || !newPassword || !confirmNewPassword) {
                emitToastr('error', 'Preencha todos os campos');
                return;
            }

            if (newPassword !== confirmNewPassword) {
                emitToastr('error', 'As senhas não conferem');
                return;
            }

            if (newPassword.length < 8) {
                emitToastr('error', 'A senha precisa ter pelo menos 8 caracteres');
                return;
            }

            const response = await Api.changePassword(oldPassword, newPassword);

            if (response.error) {
                return;
            }
            else {
                if (!response.error && response.message) {
                    emitToastr('success', 'Senha alterada com sucesso');
                    this.updatePasswordForm = {
                        showPassword: false,
                        oldPassword: '',
                        newPassword: '',
                        confirmNewPassword: ''
                    }
                }
            }
        }
    },
};
</script>


<style scoped>
.profile-picture {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;
    margin-bottom: 12px;
}
</style>